import { createContext } from "react";

const NavigationMenuContext = createContext<string | null>(null);

export const NavigationMenuProvider = NavigationMenuContext.Provider;
export const NavigationMenuConsumer = NavigationMenuContext.Consumer;

export default NavigationMenuContext;
